import { render, staticRenderFns } from "./HoldingExposureChartTooltip.vue?vue&type=template&id=5242fef4&scoped=true&"
import script from "./HoldingExposureChartTooltip.vue?vue&type=script&lang=js&"
export * from "./HoldingExposureChartTooltip.vue?vue&type=script&lang=js&"
import style0 from "./HoldingExposureChartTooltip.vue?vue&type=style&index=0&id=5242fef4&prod&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5242fef4",
  null
  
)

export default component.exports